import { Component, Input } from '@angular/core';
import { NavController, NavParams, Platform } from 'ionic-angular';


/*
  Generated class for the TreeNode component.

  See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
  for more info on Angular 2 Components.
*/
@Component({
  selector: 'tree-node',
  templateUrl: 'tree-node.html'
})
export class TreeNodeComponent {
  @Input('nodes') nodes; //nodes structure to draw
  shownGroup:any;

  constructor(public platform: Platform, public nav: NavController, public navParams: NavParams) {

  }
  //NODE CLICK FUNCTION: If the node is a child (it has the component property)
  clickNode(node) {
    if(!(node.component)){
      //NODE IS A FOLDER --> expand childs
      this.showChild(node);
    }else{
       //NODE IS A FILE --> open Page Component in data model, passing the node such as parameter.
      this.shownGroup = null;
      console.log(node);
      this.nav.push(node.component, {node: node});
    }
  }
  //FUNCTION TO CHANGE THE NODE WHICH IS ACTUALLY EXPANDED.
  showChild(node){
    if (this.isSelected(node)) {
      //The node is actually expanded --> contract node and don't show childs
      this.shownGroup = null;
    } else {
      //The node is actually contacted --> expand node and show childs
      this.shownGroup = node;
    }
  }
  //FUNCTION TO KNOW IF A FOLDER NODE HAVE TO BE EXPANDED OR CONTRATED
  isSelected(node){
    return this.shownGroup === node;
  }


}



// WEBPACK FOOTER //
// ./src/components/tree-node/tree-node.ts